import { api } from "./api"

export interface SearchResult {
  entity_type: string
  entity_id: string
  title: string
  subtitle: string | null
  url: string
  relevance_score: number
  tenant_id: string
  tenant_slug: string
  module_color: string
  required_permission: string
}

export interface FaqResult {
  question: string
  answer: string
  section: string
  relevance_score: number
}

export interface SearchResponse {
  query: string
  total: number
  execution_ms: number
  results: SearchResult[]
  faq: FaqResult[]
}

export function omniSearch(query: string, limit: number = 5): Promise<SearchResponse> {
  return api.get<SearchResponse>("/search", { q: query, limit })
}

export function searchFaq(query: string): Promise<FaqResult[]> {
  return api.get<{ data: FaqResult[] }>("/search/faq", { q: query }).then(r => r.data)
}
